import ReturnToLandingIcon from 'assets/return-to-landing.svg?react'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel, useKestrelViewerContext } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'

const StyledReturnIcon = styled(ReturnToLandingIcon)`
  path {
    fill: rgb(200, 200, 200);
  }
`

const KeyboardBadge = styled.div`
  position: absolute;
  bottom: 2px;
  right: 2px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  font-weight: 600;
`

export const ResetViewButton: React.FC = () => {
  const { sendCommand } = useKestrelViewerContext()
  const { kestrelModel } = useKestrel()

  const handleResetView = useCallback(() => {
    if (kestrelModel?.data.sceneSettings.startingView) {
      const cameraView = kestrelModel.data.sceneSettings.startingView
      sendCommand({
        command: KestrelCommands.ZOOM_TO_STARTING_VIEW,
        cameraViewId: cameraView.id,
        cameraViewPosition: cameraView.cameraPosition,
        cameraViewRotation: cameraView.cameraRotation,
      })
    } else {
      sendCommand({
        command: KestrelCommands.ZOOM_TO_STARTING_VIEW,
      })
    }
  }, [kestrelModel, sendCommand])

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null
      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        (target && target.isContentEditable)
      ) {
        return
      }

      if (event.key === 'r' || event.key === 'R') {
        handleResetView()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleResetView])

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Reset View'}>
      <ViewToggle onClick={handleResetView}>
        <StyledReturnIcon width={22} height={22} />
        <KeyboardBadge>R</KeyboardBadge>
      </ViewToggle>
    </TooltipWrapper>
  )
}
